import { apiClient, handleResponse } from './axios';

const controller = new AbortController();

async function getAllSemesters() {
  try {
    const response = await apiClient.get('/semester', {
      signal: controller.signal,
    });
    const semesters = await handleResponse(response);
    return semesters;
  } catch (error) {
    return error.response;
  }
}

async function getSemester(id) {
  try {
    const response = await apiClient.get(`/semester/${id}`);
    const semester = await handleResponse(response);
    return semester;
  } catch (error) {
    return error.response;
  }
}

async function deleteSemester(id) {
  try {
    const response = await apiClient.delete(`/semester/${id}`);
    const res = await handleResponse(response);
    return res;
  } catch (error) {
    return error.response;
  }
}

async function updateSemester(id, body) {
  try {
    const response = await apiClient.put(`/semester/${id}`, body);
    const semester = await handleResponse(response);
    return semester;
  } catch (error) {
    return error.response;
  }
}

async function addSemester(id, body) {
  try {
    const response = await apiClient.post(`/semester/${id}`, body);
    const semester = await handleResponse(response);
    return semester;
  } catch (error) {
    return error.response;
  }
}

const resourceServices = {
  getAllSemesters,
  getSemester,
  deleteSemester,
  updateSemester,
  addSemester,
};

export default resourceServices;
